"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.map");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

function getClosestBody(el) {
  if (!el) {
    return null;
  } else if (el.tagName === 'BODY') {
    return el;
  } else if (el.tagName === 'IFRAME') {
    var document_1 = el.contentDocument;
    return document_1 ? document_1.body : null;
  } else if (!el.offsetParent) {
    return null;
  }

  return getClosestBody(el.offsetParent);
}

exports.getClosestBody = getClosestBody;
var bodies = new Map();
var doc = typeof document === 'object' ? document : undefined;
exports.default = !doc ? function useLockBodyMock(_locked, _elementRef) {
  if (_locked === void 0) {
    _locked = true;
  }
} : function useLockBody(locked, elementRef) {
  if (locked === void 0) {
    locked = true;
  }

  elementRef = elementRef || react_1.useRef(doc.body);
  react_1.useEffect(function () {
    var body = getClosestBody(elementRef.current);

    if (!body) {
      return;
    }

    var bodyInfo = bodies.get(body);

    if (locked) {
      if (!bodyInfo) {
        bodies.set(body, {
          counter: 1,
          initialOverflow: body.style.overflow
        });
        body.style.overflow = 'hidden';
      } else {
        bodies.set(body, {
          counter: bodyInfo.counter + 1,
          initialOverflow: bodyInfo.initialOverflow
        });
      }
    } else {
      if (bodyInfo) {
        if (bodyInfo.counter === 1) {
          bodies.delete(body);
          body.style.overflow = bodyInfo.initialOverflow;
        } else {
          bodies.set(body, {
            counter: bodyInfo.counter - 1,
            initialOverflow: bodyInfo.initialOverflow
          });
        }
      }
    }
  }, [locked, elementRef.current]);
};